<template>
  <div v-if="transferencia" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes da Transferência entre Contas</h4>
      <router-link to="/financeiro/transferencias-contas">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="Dados da Transferência">
        <p><strong>ID:</strong> {{ transferencia.id }}</p>
        <p><strong>Data:</strong> {{ formatDate(transferencia.data_transferencia) }}</p>

        <p>
          <strong>Conta Origem:</strong>
          {{ transferencia.conta_origem_apelido }} -
          {{ transferencia.conta_origem_agencia }} -
          {{ transferencia.conta_origem_numero_conta }}
        </p>

        <p>
          <strong>Conta Destino:</strong>
          {{ transferencia.conta_destino_apelido }} -
          {{ transferencia.conta_destino_agencia }} -
          {{ transferencia.conta_destino_numero_conta }}
        </p>

        <p><strong>Valor:</strong> {{ formatCurrency(transferencia.valor) }}</p>
        <p><strong>Histórico:</strong> {{ transferencia.historico || 'Não informado' }}</p>
        <p><strong>Documento:</strong> {{ transferencia.documento || 'Não informado' }}</p>
        <p><strong>Observações:</strong> {{ transferencia.observacoes || 'Não informado' }}</p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    Carregando...
  </div>
</template>

<script>
import axios from '@/services/axios'
import FormSection from '@/components/Layout/FormSection.vue'

export default {
  components: { FormSection },
  data() {
    return {
      transferencia: null
    }
  },
  methods: {
    formatCurrency(n) {
      const v = typeof n === 'number' ? n : parseFloat(n || 0)
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(isNaN(v) ? 0 : v)
    },
    formatDate(d) {
      if (!d) return '—'
      const dt = new Date(`${String(d).slice(0, 10)}T00:00:00`)
      return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString('pt-BR')
    },
    async carregarTransferencia() {
      try {
        const { data } = await axios.get(`/financeiro/transferencias-contas/${this.$route.params.id}`)
        this.transferencia = data
      } catch (error) {
        console.error('Erro ao carregar transferência:', error)
      }
    }
  },
  mounted() {
    this.carregarTransferencia()
  }
}
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}
.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}
.form-content {
  margin-top: 1.5rem;
}
button.btn-sm {
  padding: 6px 12px;
}
</style>